import { CalendarDays, CircleCheck, Sheet, ShieldCheck } from "lucide-react";

export const COMMUNITY_NAME = "communityName";
export const DOCUMENT_TYPE = "documentType";
export const HEADER_FIELDS = "HEADER";
export const LINE_ITEM_FIELDS = "LINE_ITEM";

export const FIELD_TABS = [
  {
    label: "Header Fields",
    value: HEADER_FIELDS,
    description:
      "Controls posting-line, billing, tax , and subledger attributes.",
  },
  {
    label: "Line Item Fields",
    value: LINE_ITEM_FIELDS,
    description:
      "Controls posting-line, billing, tax , and subledger attributes.",
  },
] as const;

export const featureItems = [
  {
    title: "Dynamic UI field rendering enabled",
    icon: CircleCheck,
  },
  {
    title: "Excel template structure driven by config",
    icon: Sheet,
  },
  {
    title: "Upload validation aligned to active rules",
    icon: ShieldCheck,
  },
  {
    title: "Version and effective-date controlled rollout",
    icon: CalendarDays,
  },
];